
<div>
    <a :href="storeUrl" class="image align-self-center logo-container">
        <img v-if="item.thumbnail" :src="item.thumbnail.public_path + '?size=list'" class="logo" :alt="item.thumbnail.alt"/>
    </a>

    <div class="body">
        <h4 class="catalog-item-title text-center py-2 py-sm-3">{{ item.title }}</h4>
        <a class="btn btn-primary d-flex flex-nowrap align-items-center justify-content-center" :href="storeUrl">
            <span>{{btnText}}</span>
            <img src="https://asurcloudrunprod-16905.kxcdn.com/public-assets/right-arrow-icon" alt="arrow" class="arrow-icon ms-3">
        </a>
    </div>
</div>
